import { getRectDirectedCycle } from '../../preprocess/get-rect-directed-cycle';
import { Point } from '../../type/common.interface';
import { Cache } from '../../utils/cache';

const detectRectCache = new Cache<{
    rectDirectedCycle: Point[];
}>(1000);

function generateDetectRectCacheKey(width: number, height: number): string {
    return `${width},${height}`;
}

export function detectRect(width: number, height: number) {
    if (!width || !height) return { rectDirectedCycle: [] as Point[] };

    const cacheKey = generateDetectRectCacheKey(width, height);
    const cachedResult = detectRectCache.get(cacheKey);

    if (cachedResult) return cachedResult;

    // 顺时针获取四周边缘点构成一个有向环
    const rectDirectedCycle = getRectDirectedCycle(width, height);

    // 缓存有向环
    detectRectCache.set(cacheKey, { rectDirectedCycle });

    return { rectDirectedCycle };
}
